import store from 'store2';
import { get as _get, includes as _includes } from 'lodash';

export const isLoggedIn = () => {
  const userFromLocalStorage = store('swsmUser');

  return _get(userFromLocalStorage, 'v', false);
};
